// @flow
import React, { Component } from 'react';
import { convertCurrencyValue } from '../../utils/currency';
import { FormattedNumber } from 'react-intl';

type Props = $ReadOnly<{|
    children?: any,
    conversions: any[],
    convert?: boolean,
    fractionDigits?: number,
    locale: string,
    noFraction?: boolean,
    sourceCurrency: string,
    targetCurrency: string,
    value: number,
|}>;

export default class FormattedCurrency extends Component<Props> {
    static defaultProps = {
        conversions: [],
        convert: true,
        locale: '',
        noFraction: false,
        sourceCurrency: 'usd',
        targetCurrency: 'usd',
        value: 0,
    };

    convertValueForCurrency = (value: number) => {
        // for duration of experiment, non en-gb or usd selected currency do not convert value
        if (this.props.locale !== 'en-gb' || this.props.targetCurrency.toLowerCase() === 'usd') {
            return value;
        }
        const { conversions, sourceCurrency, targetCurrency } = this.props;
        const convertedValue = convertCurrencyValue(conversions, sourceCurrency, targetCurrency, value);
        return convertedValue;
    };

    render() {
        const { children, convert, noFraction, sourceCurrency, targetCurrency, value } = this.props;
        let numFractionDigits = !noFraction && sourceCurrency.toLowerCase() !== targetCurrency.toLowerCase() ? 2 : 0;
        numFractionDigits = this.props.fractionDigits !== undefined ? this.props.fractionDigits : numFractionDigits;
        const convertedValue = convert ? this.convertValueForCurrency(value) : value;
        // for duration of experiment, only show currency symbol if not USD
        const displayCurrency =
            this.props.locale !== 'en-gb' || targetCurrency.toLowerCase() === 'usd' ? sourceCurrency : targetCurrency;
        return (
            <FormattedNumber
                currency={displayCurrency}
                maximumFractionDigits={numFractionDigits}
                minimumFractionDigits={numFractionDigits}
                style="currency"
                value={convertedValue}
            >
                {children}
            </FormattedNumber>
        );
    }
}
